
import { defineComponent, PropType } from 'vue'
import { RouteLocationRaw } from 'vue-router'

/** Плитка показателя; с `to` становится ссылкой в нужный раздел. Цвет задаёт tone. */
export default defineComponent({
  name: 'StatTile',
  props: {
    label: { type: String, required: true },
    value: { type: [String, Number], required: true },
    hint: { type: String, default: '' },
    tone: {
      type: String as PropType<'ok' | 'warning' | 'danger' | 'neutral'>,
      default: 'neutral',
    },
    to: { type: [Object, String] as PropType<RouteLocationRaw | undefined>, default: undefined },
  },
})
